module.exports = __webpack_public_path__ + "img/japan-pneumonia-male.cf4ae715.png";